import React, { useContext, useState } from 'react'
import { Modal } from 'react-bootstrap'
import './modalNavbar.css'
import { Link } from 'react-router-dom'
import { AuthContext } from '../../../context/Authcontext'
import { useToggle } from '../../../context/toggle/toggleBtn'

export const ModalNavbar = ({ showModal, toggleModal }) => {

const {logout} = useContext(AuthContext)


    return (
        <Modal
            show={showModal}
            onHide={toggleModal}
            className="modal-dialog-centered "
            dialogClassName='classModalNav'
            contentClassName="contentWidht" //👉 Clase para el modal-content
        >
            <Modal.Header closeButton>
                <Modal.Title>
                    <p>Perfil</p>
                </Modal.Title>
            </Modal.Header>

            <Modal.Body className='ModalBodyStyle'>
                <Link to="/profile"><i className="bi bi-person bi-class"  onClick={() => toggleModal() } >
                    <p>Mi perfil</p>
                </i></Link>
                <Link ><i className="bi bi-box-arrow-right bi-class" onClick={() => {logout()}}>
                    <p>Cerrar Sesión</p>
                </i></Link>
            </Modal.Body>
        </Modal>
    )
}
